import { useQuery } from "@tanstack/react-query";
import { InvestmentPlan } from "@/lib/db/schema";

const fetchInvestmentPlans = async (): Promise<InvestmentPlan[]> => {
  const response = await fetch("/api/admin/investment-plans");
  if (!response.ok) {
    throw new Error("Failed to fetch investment plans");
  }
  return response.json();
};

export const useInvestmentPlans = () => {
  return useQuery({
    queryKey: ["investment-plans"],
    queryFn: fetchInvestmentPlans,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};